export var GPlayerPronoun;
(function (GPlayerPronoun) {
    GPlayerPronoun["HE_HIM"] = "He/Him";
    GPlayerPronoun["SHE_HER"] = "She/Her";
    GPlayerPronoun["THEY_THEM"] = "They/Them";
    GPlayerPronoun["IT_ITS"] = "It/Its";
    GPlayerPronoun["OTHER"] = "Other";
    GPlayerPronoun["MY_NAME"] = "Use my name";
})(GPlayerPronoun || (GPlayerPronoun = {}));
